var _circle, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiaterisk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_382_2610)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1632 9L17.8879 9.5712H15.0159L15.1632 9Z",
    fill: "url(#paint1_linear_382_2610)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4169 24.0055L8 12.3308L11.3603 11.5312V22.106H17.4236L18.4735 22.3262L11.4169 24.0055Z",
    fill: "url(#paint2_linear_382_2610)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5525 22.1094H21.2639V10.2811L24.3098 10.9197L21.277 22.6804L18.5525 22.1094Z",
    fill: "url(#paint3_linear_382_2610)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1215 9.80078H11.6174V21.8753H21.0114V9.80078H20.1215ZM20.1944 15.9534H12.4342V15.7222H20.1944V15.9534ZM20.1944 14.6397H12.4342V14.4087H20.1944V14.6397ZM20.1944 13.3244H12.4342V13.0935H20.1944V13.3244ZM20.1944 12.0109H12.4342V11.7799H20.1944V12.0109Z",
    fill: "url(#paint4_linear_382_2610)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1938 16.207C18.3235 16.207 20.05 17.796 20.05 19.755C20.05 21.7141 18.3234 23.3027 16.1938 23.3027C14.0642 23.3027 12.3373 21.714 12.3373 19.755C12.3373 17.7959 14.0642 16.207 16.1938 16.207ZM16.1938 17.0939C14.5989 17.0939 13.3015 18.2877 13.3015 19.755C13.3015 21.2221 14.5989 22.4156 16.1938 22.4156C17.7887 22.4156 19.086 21.2221 19.086 19.755C19.086 18.2877 17.7887 17.0939 16.1938 17.0939ZM12.4083 21.9831C12.7599 22.4863 13.2248 22.9143 13.7715 23.2377L11.412 25.4081C11.0355 25.7546 10.4246 25.7546 10.0488 25.4081C9.67229 25.0624 9.67229 24.5007 10.0488 24.154L12.4083 21.9831Z",
    fill: "url(#paint5_linear_382_2610)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3215,
    cy: 19.7626,
    rx: 2.97316,
    ry: 2.7353,
    fill: "url(#paint6_linear_382_2610)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.948 19.0873H14.483C14.598 19.0873 14.696 19.1046 14.777 19.1393C14.8581 19.1739 14.9201 19.2251 14.963 19.293C15.0066 19.3602 15.0284 19.4433 15.0284 19.5423C15.0284 19.6178 15.0146 19.6843 14.9869 19.7418C14.9592 19.7993 14.9201 19.8478 14.8695 19.8873C14.8189 19.926 14.7587 19.9562 14.6887 19.9776L14.6098 20.0161H14.1288L14.1267 19.8093H14.4872C14.5495 19.8093 14.6015 19.7983 14.643 19.7761C14.6846 19.7539 14.7157 19.7238 14.7365 19.6857C14.758 19.6469 14.7687 19.6033 14.7687 19.5548C14.7687 19.5022 14.7583 19.4565 14.7376 19.4177C14.7175 19.3782 14.6863 19.3481 14.6441 19.3273C14.6018 19.3058 14.5481 19.2951 14.483 19.2951H14.2088V20.5999H13.948V19.0873ZM14.8113 20.5999L14.456 19.9205L14.7292 19.9195L15.0897 20.5864V20.5999H14.8113Z",
    fill: "url(#paint7_linear_382_2610)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5666 19.0873V20.5999H15.3058V19.0873H15.5666Z",
    fill: "url(#paint8_linear_382_2610)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6865 20.2103C16.6865 20.1792 16.6817 20.1515 16.672 20.1272C16.663 20.103 16.6467 20.0808 16.6231 20.0607C16.5996 20.0407 16.5663 20.0213 16.5234 20.0026C16.4812 19.9832 16.4271 19.9634 16.3613 19.9434C16.2893 19.9212 16.2228 19.8966 16.1619 19.8696C16.1016 19.8419 16.049 19.81 16.004 19.774C15.9589 19.7373 15.924 19.6954 15.899 19.6483C15.8741 19.6005 15.8616 19.5455 15.8616 19.4831C15.8616 19.4215 15.8744 19.3654 15.9001 19.3148C15.9264 19.2643 15.9634 19.2206 16.0112 19.1839C16.0597 19.1465 16.1169 19.1178 16.1826 19.0977C16.2484 19.0769 16.3212 19.0665 16.4008 19.0665C16.513 19.0665 16.6096 19.0873 16.6907 19.1289C16.7724 19.1704 16.8351 19.2262 16.8787 19.2961C16.923 19.3661 16.9452 19.4433 16.9452 19.5278H16.6865C16.6865 19.4779 16.6758 19.4339 16.6543 19.3959C16.6335 19.3571 16.6017 19.3266 16.5587 19.3044C16.5165 19.2823 16.4628 19.2712 16.3977 19.2712C16.3361 19.2712 16.2848 19.2805 16.2439 19.2992C16.2031 19.3179 16.1726 19.3432 16.1525 19.3751C16.1324 19.4069 16.1224 19.443 16.1224 19.4831C16.1224 19.5115 16.129 19.5375 16.1421 19.561C16.1553 19.5839 16.1754 19.6054 16.2024 19.6255C16.2294 19.6448 16.2633 19.6632 16.3042 19.6805C16.3451 19.6978 16.3932 19.7144 16.4486 19.7304C16.5324 19.7553 16.6055 19.783 16.6678 19.8135C16.7301 19.8433 16.7821 19.8772 16.8236 19.9153C16.8652 19.9534 16.8964 19.9967 16.9171 20.0452C16.9379 20.093 16.9483 20.1473 16.9483 20.2083C16.9483 20.272 16.9355 20.3295 16.9099 20.3807C16.8842 20.4313 16.8475 20.4746 16.7997 20.5106C16.7527 20.5459 16.6959 20.5733 16.6294 20.5927C16.5636 20.6114 16.4902 20.6207 16.4091 20.6207C16.3364 20.6207 16.2647 20.611 16.1941 20.5916C16.1241 20.5722 16.0604 20.5428 16.0029 20.5033C15.9454 20.4631 15.8997 20.4133 15.8658 20.3537C15.8319 20.2935 15.8149 20.2232 15.8149 20.1428H16.0756C16.0756 20.192 16.084 20.2339 16.1006 20.2685C16.1179 20.3032 16.1418 20.3315 16.1723 20.3537C16.2027 20.3752 16.2381 20.3911 16.2782 20.4015C16.3191 20.4119 16.3627 20.4171 16.4091 20.4171C16.4701 20.4171 16.521 20.4084 16.5618 20.3911C16.6034 20.3738 16.6346 20.3496 16.6553 20.3184C16.6761 20.2872 16.6865 20.2512 16.6865 20.2103Z",
    fill: "url(#paint9_linear_382_2610)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4397 19.0873V20.5999H17.1789V19.0873H17.4397ZM18.3487 19.0873L17.7358 19.8156L17.3867 20.1854L17.341 19.9267L17.5903 19.6192L18.0308 19.0873H18.3487ZM18.0682 20.5999L17.5706 19.8831L17.7503 19.7054L18.3778 20.5999H18.0682Z",
    fill: "url(#paint10_linear_382_2610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_382_2610",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_382_2610",
    x1: 16.4519,
    y1: 8.88576,
    x2: 16.4519,
    y2: 9.5712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093851"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_382_2610",
    x1: 13.2368,
    y1: 9.03641,
    x2: 13.2368,
    y2: 24.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093851"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_382_2610",
    x1: 21.4311,
    y1: 7.80127,
    x2: 21.4311,
    y2: 22.6804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093851"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_382_2610",
    x1: 16.3144,
    y1: 7.38588,
    x2: 16.3144,
    y2: 21.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093851"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_382_2610",
    x1: 14.9082,
    y1: 14.3148,
    x2: 14.9082,
    y2: 25.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B4B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_382_2610",
    x1: 16.3215,
    y1: 15.9332,
    x2: 16.3215,
    y2: 22.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093851"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_382_2610",
    x1: 16.1629,
    y1: 18.7557,
    x2: 16.1629,
    y2: 20.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B4B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_382_2610",
    x1: 16.1629,
    y1: 18.7557,
    x2: 16.1629,
    y2: 20.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B4B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_382_2610",
    x1: 16.1629,
    y1: 18.7557,
    x2: 16.1629,
    y2: 20.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B4B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_382_2610",
    x1: 16.1629,
    y1: 18.7557,
    x2: 16.1629,
    y2: 20.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B4B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiaterisk);
export default __webpack_public_path__ + "static/media/initiaterisk.8ab60264f6a126c6c77c3c53a0350947.svg";
export { ForwardRef as ReactComponent };